// eye.js
window.trackingEnabled = true;
const svgStates = new WeakMap();

function updateOne(s, clientX, clientY, instant = false) {
  const pt = s.svg.createSVGPoint();
  pt.x = clientX;
  pt.y = clientY;
  const loc = pt.matrixTransform(s.svg.getScreenCTM().inverse());
  const dx = loc.x - s.cx,
        dy = loc.y - s.cy;
  const d = Math.hypot(dx, dy);
  const r = d < s.maxR ? d : s.maxR;
  const θ = Math.atan2(dy, dx);
  const tx = s.cx + Math.cos(θ) * r;
  const ty = s.cy + Math.sin(θ) * r;

  if (instant) {
    s.px = tx; s.py = ty;
  } else {
    const f = s.minF + (s.maxF - s.minF) * (r / s.maxR);
    s.px += (tx - s.px) * f;
    s.py += (ty - s.py) * f;
  }

  s.pupil.setAttribute('x', s.px - s.pw/2);
  s.pupil.setAttribute('y', s.py - s.ph/2);
}

function blinkAll(states) {
  states.forEach(s => {
    s.closedEye.style.opacity = '1';
    s.openEye.style.opacity   = '0';
    s.pupil.style.opacity     = '0';
  });
  setTimeout(() => {
    states.forEach(s => {
      s.closedEye.style.opacity = '0';
      s.openEye.style.opacity   = '1';
      s.pupil.style.opacity     = '1';
    });
  }, 150);
}

function scheduleBlink(states) {
  setTimeout(() => {
    blinkAll(states);
    scheduleBlink(states);
  }, Math.random() * 3000 + 2000);
}

function initEyes(svg) {
  const eyeGroups = Array.from(svg.querySelectorAll('g.eye'));
  if (!eyeGroups.length) return;
  const states = eyeGroups.map(el => {
    const pupil     = el.querySelector('.pupil');
    const openEye   = el.querySelector('.openEye');
    const closedEye = el.querySelector('.closedEye');
    const neutral   = el.querySelector('.neutral');
    const anger     = el.querySelector('.anger');
    const shyEls    = Array.from(el.querySelectorAll('.shy'));
    const sickEls   = [el.querySelector('.sick1'), el.querySelector('.sick2')];
    const bb        = openEye.getBBox();
    const cx        = bb.x + bb.width/2;
    const cy        = bb.y + bb.height/2;
    const pw        = parseFloat(pupil.getAttribute('width'));
    const ph        = parseFloat(pupil.getAttribute('height'));
    const baseR     = Math.min(bb.width, bb.height)/2 - Math.max(pw,ph)/2;
    const maxR      = baseR * 1.2;
    return {
      svg, pupil, openEye, closedEye, neutral, anger,
      shyEls, sickEls, cx, cy, pw, ph,
      px: cx, py: cy, maxR,
      minF: 0.05, maxF: 0.2,
      isAngry: false, isShy: false, isSick: false,
      clickCount: 0, firstClick: null
    };
  });
  svgStates.set(svg, states);

  let idleTimer;
  let conversationActive = false;

  function hideAll(s) {
    s.neutral.style.opacity = '0';
    s.anger.style.opacity   = '0';
    s.shyEls.forEach(el => el.style.opacity = '0');
    s.sickEls.forEach(el => el.style.opacity = '0');
  }

  function showNeutral(s) {
    hideAll(s);
    s.neutral.style.opacity = '1';
  }

  function showAllNeutral() {
    states.forEach(showNeutral);
  }

  function startIdle() {
    if (conversationActive) return;
    clearTimeout(idleTimer);
    idleTimer = setTimeout(function idleLoop() {
      blinkAll(states);
      const angle = Math.random() * Math.PI * 2;
      const dist  = states[0].maxR * (0.5 + Math.random() * 0.5);
      states.forEach(s => {
        const tx = s.cx + Math.cos(angle) * dist;
        const ty = s.cy + Math.sin(angle) * dist;
        const pt = s.svg.createSVGPoint();
        pt.x = tx; pt.y = ty;
        const screenPt = pt.matrixTransform(s.svg.getScreenCTM());
        updateOne(s, screenPt.x, screenPt.y, true);
      });
      idleTimer = setTimeout(idleLoop, Math.random() * 3000 + 2000);
    }, 0);
  }

  function stopIdle() {
    clearTimeout(idleTimer);
  }

  function handleMouseMove(e) {
    stopIdle();
    showAllNeutral();
    if (!window.trackingEnabled) return;
    const r = svg.getBoundingClientRect();
    if (e.clientX < r.left || e.clientX > r.right ||
        e.clientY < r.top  || e.clientY > r.bottom) return;
    states.forEach(s => {
      if (!s.isAngry && !s.isShy && !s.isSick) {
        updateOne(s, e.clientX, e.clientY, false);
      }
    });
  }

  function handleMouseLeave() {
    startIdle();
  }

  function handleMouseEnter() {
    stopIdle();
    showAllNeutral();
  }

  function handleClick() {
    const now = Date.now();
    states.forEach(s => {
      if (!s.firstClick || now - s.firstClick > 2000) {
        s.firstClick = now;
        s.clickCount = 1;
      } else {
        s.clickCount++;
      }
      if (s.clickCount >= 5) {
        // триггерим «anger» для всех глаз сразу
        states.forEach(u => {
          u.isAngry = true;
          hideAll(u);
          u.anger.style.opacity = '1';
        });
        setTimeout(() => {
          states.forEach(u => {
            u.isAngry = false;
            showNeutral(u);
          });
          startIdle();
        }, 3000);
        states.forEach(u => { u.clickCount = 0; u.firstClick = null; });
      }
    });
  }

  svg.addEventListener('mousemove', handleMouseMove);
  svg.addEventListener('mouseleave', handleMouseLeave);
  svg.addEventListener('mouseenter', handleMouseEnter);
  svg.addEventListener('click', handleClick);

  startIdle();
  scheduleBlink(states);
}

function initializeAllSvgEyes() {
  document.querySelectorAll('svg').forEach(svg => {
    if (!svgStates.has(svg) && svg.querySelector('g.eye')) {
      initEyes(svg);
    }
  });
}

document.addEventListener('DOMContentLoaded', initializeAllSvgEyes);
new MutationObserver(initializeAllSvgEyes)
  .observe(document.body, { subtree: true, childList: true });
